// src/utils/geo.js
// Tiny, dependency-free geo helpers for the anonymous session aggregate
// (the privacy-safe replacement for storing precise per-user location).

const BASE32 = '0123456789bcdefghjkmnpqrstuvwxyz';

// Standard geohash encoder. Precision 5 ≈ a ~4.9km cell — coarse enough to be
// non-identifying, fine enough to light up a city on the aggregate world map.
export function geohashEncode(lat, lng, precision = 5) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  let idx = 0, bit = 0, evenBit = true, hash = '';
  let latMin = -90, latMax = 90, lngMin = -180, lngMax = 180;
  while (hash.length < precision) {
    if (evenBit) {
      const mid = (lngMin + lngMax) / 2;
      if (lng >= mid) { idx = idx * 2 + 1; lngMin = mid; } else { idx = idx * 2; lngMax = mid; }
    } else {
      const mid = (latMin + latMax) / 2;
      if (lat >= mid) { idx = idx * 2 + 1; latMin = mid; } else { idx = idx * 2; latMax = mid; }
    }
    evenBit = !evenBit;
    if (++bit === 5) { hash += BASE32[idx]; bit = 0; idx = 0; }
  }
  return hash;
}

// Round to ~1.1km (2 decimal places) so the stored point can't pin a home.
export function coarsen(n) {
  return Math.round(n * 100) / 100;
}
